export default __webpack_public_path__ + "static/media/learning-hrz.124b8c0f.webp";